module.exports = __webpack_public_path__ + "static/media/011.1cc83df9.jpg";